export default {"src":"/_next/static/media/school.5748f43d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};